import React from "react";
import Head from "next/head";

const ApplicationLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <>
      <Head>
        <title>Raycast</title>
        <meta name="viewport" content="width=device-width,initial-scale=1" />
        <meta name="description" content="Limitless productivity in a productivity-less world." />
      </Head>
      {children}
    </>
  );
};

export default ApplicationLayout;
